import React, {useCallback, useState} from 'react';
import I18n from 'app/i18n';
import {getLinkPath, isGuest, HardRedirect} from 'app/utils';
import {linkAndroid, linkIOSDownload} from 'app/utils/app_links';
import FastRegistrationWithEmailContent from 'app/components/auth/FastRegistrationWithEmailContent';
import {UserStore} from 'app/store/UserStore';
import LineInterface from 'app/interfaces/LineInterface';
import Get from 'app/utils/Get';
import LandingLadderGameStreamerPhoto from './LandingLadderGameStreamerPhoto';
// @ts-ignore
import SvgLogoEgb from 'images/logos/egb-logo.svg';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface LandingLadderGameProps {
    userStore?: UserStore
    game_id: number
}

const COUNT_OF_DECIMAL = 3;
const CSGO_GAME = 2;
const HEARTHSTONE_GAME = 9;
const HOMM_GAME = 56;
const QUAKE_LIVE_GAME = 71;

const FIRST_TEAM = 1;
const SECOND_TEAM = 2;
const TEAM_VIEW_BOTH = 3;

const LANDINGS_WITH_2_GAMERS = [QUAKE_LIVE_GAME];

const renderTeam = (line: LineInterface | null, showTwoGamers: boolean, team_num: number) => {
    const statusWinLose = team_num === 1 ? 'win' : 'lose';

    if (showTwoGamers) {
        return <LandingLadderGameStreamerPhoto gamer={team_num === FIRST_TEAM ? line.gamer_1 : line.gamer_2}/>;
    }
    return <span className={`status ${statusWinLose}`}>{I18n.t(`status_${statusWinLose}`)}</span>;
};

const renderStreamerName = (line: LineInterface | null, showTwoGamers: boolean) => {
    if (showTwoGamers) {
        return <span className="streamer-name">
            {line?.tourn}
        </span>;
    }

    return <>
        <LandingLadderGameStreamerPhoto
            gamer={line.banner === FIRST_TEAM ? line.gamer_1 : line.gamer_2}/>
        <span className="streamer-name">
            {line.banner === FIRST_TEAM ? line.gamer_1.nick : line.gamer_2.nick}
        </span>
    </>;
};

const renderCoeff = (line: LineInterface | null, showTwoGamers: boolean, team_num: number) => {
    let coeff = '';
    if (showTwoGamers) {
        coeff = team_num === FIRST_TEAM ? line.coef_1 : line.coef_2;
    } else {
        coeff = line.banner === team_num ? line.coef_1 : line.coef_2;
    }
    return Number(coeff).toFixed(COUNT_OF_DECIMAL);
};


const LandingLadderGame: React.FC<LandingLadderGameProps> = props => {
    const [line, setLine] = useState<LineInterface | null>(null);
    const [pressedButton, setPressedButton] = useState<boolean>(false);

    const getLines = () => {
        new Get({params: {all_lines: LANDINGS_WITH_2_GAMERS.includes(props.game_id), game_id: props.game_id}, url: '/api/v2/banner/landing'})
            .execute()
            .then(response => response.json())
            .then(data => {
                setLine(data);
            });
    };

    if (isGuest()) {
        getLines();
    } else {
        return <HardRedirect to="/play/bets" />;
    }

    const onClickRegistration = () => {
        setPressedButton(prevState => !prevState);
    };

    const classNameByType = () => {
        switch (props.game_id) {
        case CSGO_GAME: return 'cs-go';
        case HEARTHSTONE_GAME: return 'hearthstone';
        case HOMM_GAME: return 'heroes-3';
        case QUAKE_LIVE_GAME: return 'quake-live';
        default: return 'dota-2';
        }
    };

    const title1ByType = () => {
        switch (props.game_id) {
        case QUAKE_LIVE_GAME: return I18n.t('title_landing_ladder_exclusive_rates');
        default: return I18n.t('title_landing_ladder_game_1');
        }
    };

    const title2ByType = () => {
        switch (props.game_id) {
        case QUAKE_LIVE_GAME: return I18n.t('title_landing_ladder_on_game', {game: 'Quake Live'});
        default: return I18n.t('title_landing_ladder_game_2');
        }
    };

    const handleOnClickRegistration = useCallback(() => onClickRegistration(), [onClickRegistration]);

    const showTwoGamers = line?.banner === TEAM_VIEW_BOTH;

    const classNameLine = () => showTwoGamers ? 'line-with-2-gamers' : '';

    return <main className={`landing-promo-content ${classNameByType()}${pressedButton ? ' no-scroll' : ''}`}>
        <div className="left-landing-ladder-game">
            <a href={getLinkPath('/')} className="logo-landing-promo ladder-game">
                <img src={SvgLogoEgb} alt="EGB.com" title="EGB.COM"/>
            </a>
            <div className="middle-landing-ladder-game">
                <div className="greetings-landing-ladder-game">
                    <div className="title-and-hero-landing-ladder-game">
                        <div className="title-landing-ladder-game">
                            <span className="part-first">{title1ByType()}</span>
                            <span className="part-second">{title2ByType()}</span>
                        </div>
                        <span className="hero-landing-ladder-game"></span>
                    </div>
                    {line && <div className={`line-landing-ladder-game ${classNameLine()}`}>
                        <div className="line-inner-landing-ladder-game">
                            <div className="team">
                                {renderTeam(line, showTwoGamers, FIRST_TEAM)}
                                <span className="balance">
                                    {renderCoeff(line, showTwoGamers, FIRST_TEAM)}
                                </span>
                            </div>
                            <div className="streamer">
                                {renderStreamerName(line, showTwoGamers)}
                                <span className="line-live">{I18n.t('line_live')}</span>
                            </div>
                            <div className="team">
                                {renderTeam(line, showTwoGamers, SECOND_TEAM)}
                                <span className="balance">
                                    {renderCoeff(line, showTwoGamers, SECOND_TEAM)}
                                </span>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="bonus-landing-ladder-game">
                    <span className="bonus">$600!</span>
                    <div className="bonus-title">
                        <span className="part-first">{I18n.t('bonus')}</span>
                        <span className="part-second">{I18n.t('bonus_landing_ladder_game')}</span>
                    </div>
                </div>
            </div>
            <div className="landing-promo-footer">
                <div className="about-landing-ladder-game">
                    <div className="item">
                        <span className="item-num">1</span>
                        <span className="item-title">{I18n.t('about_landing_ladder_game_1')}</span>
                    </div>
                    <div className="item">
                        <span className="item-num">2</span>
                        <span className="item-title">{I18n.t('about_landing_ladder_game_2')}</span>
                    </div>
                    <div className="item">
                        <span className="item-num">3</span>
                        <span className="item-title">{I18n.t('about_landing_ladder_game_3')}</span>
                    </div>
                </div>
                <div className="landing-promo-content-rules">
                    <div className="row">
                        <a
                            className="landing-promo-rules"
                            href={'/public/terms_and_conditions'}
                        >
                            {I18n.t('advertising.terms_conditions')}
                        </a>
                    </div>
                    <div className="row">
                        <div className="landing-promo-list-app">
                            <a
                                rel="noopener noreferrer"
                                target="_blank"
                                className="item"
                                href={linkIOSDownload()}
                            >
                                <SpriteIcon name="#svg-app_store" className="svg-default"/>
                            </a>
                            <a
                                id="android_app_download"
                                className="item"
                                href={linkAndroid()}
                            >
                                <SpriteIcon name="#svg-google_play" className="svg-default" size={{height: 50, width: 150}}/>
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="landing-promo-list-payment">
                            <span className="item visa">
                                <SpriteIcon name="#svg-visa" className="svg-default"/>
                            </span>
                            <span className="item mastercard">
                                <SpriteIcon name="#svg-master_card" className="svg-default"/>
                            </span>
                            <span className="item license">
                                <SpriteIcon name="#svg-license" className="svg-default"/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={`landing-promo-center${pressedButton ? ' active' : ''}`}>
            <button
                className="button-close-registration-landing-promo"
                onClick={handleOnClickRegistration}
            >
                <SpriteIcon name="#svg-close" size={{height: 21, width: 21}}/>
            </button>
            <div className="landing-promo-registration">
                <div className="landing-promo-registration-top">
                    <h2>{I18n.t('about_landing_ladder_game_1')}</h2>
                    <p>{I18n.t('form_landing_ladder_game')}</p>
                </div>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <FastRegistrationWithEmailContent/>
            </div>
        </div>
        <div className="mobile-button-landing-promo">
            <button
                className="button-registration-landing-promo"
                onClick={handleOnClickRegistration}
            >{I18n.t('user.registration')}</button>
        </div>
    </main>;
};

export default LandingLadderGame;
